<script setup lang="ts">
defineProps({
  clickable: {
    type: Boolean,
    default: false
  },
  gradient: {
    type: Boolean,
    default: false
  },
  variant: {
    type: String,
    default: 'default',
    validator: (value: string) => ['default', 'bottomBar', 'compact'].includes(value)
  }
})
</script>

<template>
  <div :class="['sunken-metric', `sunken-metric--${variant}`, { 'cursor-pointer': clickable, 'sunken-metric--gradient': gradient }]">
    <slot />
  </div>
</template>

<style scoped>
.sunken-metric {
  background: rgba(15, 18, 22, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.06);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
}

.sunken-metric--default {
  min-height: 1.75rem;
  padding: 0.5rem 0.75rem;
}

.sunken-metric--gradient {
  background: linear-gradient(to top, rgba(15, 18, 22, 0.9), rgba(30, 35, 42, 0.85));
}

.sunken-metric--bottomBar {
  height: 2rem;
  padding: 0 0.5rem;
}

.sunken-metric--compact {
  min-height: 1.35rem;
  padding: 0.15rem 0.4rem;
}
</style>
